"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const core_1 = require("@smash-sdk/core");
const core_2 = require("@smash-sdk/core");
const errors_1 = require("./errors");
__exportStar(require("./errors"), exports);
__exportStar(require("./types/CreateAccountLink/CreateAccountLink"), exports);
__exportStar(require("./types/CreateAccountTeamLink/CreateAccountTeamLink"), exports);
__exportStar(require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLink"), exports);
__exportStar(require("./types/CreateAccountUserLink/CreateAccountUserLink"), exports);
__exportStar(require("./types/DeleteAccountLink/DeleteAccountLink"), exports);
__exportStar(require("./types/DeleteLink/DeleteLink"), exports);
__exportStar(require("./types/GetLink/GetLink"), exports);
__exportStar(require("./types/GetTarget/GetTarget"), exports);
__exportStar(require("./types/GetTeamLink/GetTeamLink"), exports);
__exportStar(require("./types/GetUserLink/GetUserLink"), exports);
__exportStar(require("./types/ListLinks/ListLinks"), exports);
__exportStar(require("./types/ListTeamLinks/ListTeamLinks"), exports);
__exportStar(require("./types/ListUserLinks/ListUserLinks"), exports);
__exportStar(require("./types/LockAccountUserLink/LockAccountUserLink"), exports);
const endpoints = {
    global: "https://link.fromsmash.co",
};
core_2.config.setHosts("link", endpoints, false);
class Link extends core_1.Client {
    constructor(params = {}) {
        super(Object.assign(Object.assign({ service: "link" }, params), { type: "global", userAgent: "@smash-sdk/link@0.1.2" }));
        this.errors = errors_1.errors;
    }
    createAccountLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account/:accountId/link",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        user: params["user"],
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    createAccountTeamLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account/:accountId/team/:teamId/link",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        user: params["user"],
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountTeamLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    createAccountTeamUserLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account/:accountId/team/:teamId/user/:userId/link",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountTeamUserLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    createAccountUserLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account/:accountId/user/:userId/link",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountUserLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    deleteAccountLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/account/:accountId/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteAccountLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    deleteLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getTarget(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/target/:targetId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        targetId: params["targetId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTargetError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getTeamLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getUserLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    listLinks() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/links",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListLinksError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    listTeamLinks(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/links",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamLinksError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    listUserLinks(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/links",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserLinksError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    lockAccountUserLink(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/account/:accountId/user/:userId/link/:linkId/lock",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        userId: params["userId"],
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        target: params["target"],
                        region: params["region"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.LockAccountUserLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
}
exports.Link = Link;
Link.errors = errors_1.errors;
